import { render, staticRenderFns } from "./UpsKeys.vue?vue&type=template&id=158ac751&scoped=true&lang=pug&"
import script from "./UpsKeys.vue?vue&type=script&lang=js&"
export * from "./UpsKeys.vue?vue&type=script&lang=js&"
import style0 from "./UpsKeys.vue?vue&type=style&index=0&id=158ac751&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158ac751",
  null
  
)

/* custom blocks */
import block0 from "./UpsKeys.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports